/**
 * @desc 导出箱号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  boxCodeBatchNumber: string,
  params: API.srm.supplierBox.exportWithinBatchBox.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierBox/exportWithinBatchBox/${boxCodeBatchNumber}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
